// Static brand + catalog content for A Flat Records

export const ASSETS = {
  logo: "https://customer-assets-v7afamib.emergentagent.net/job_27ef5461-843b-4991-ad70-93e46726bb12/artifacts/rmzg79i0_LOGO.webp",
  logoTransparent:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/b1tdt1zc_A%20Flat%20Records%20logo_Transparent.webp",
  founder:
    "https://customer-assets-v7afamib.emergentagent.net/job_27ef5461-843b-4991-ad70-93e46726bb12/artifacts/cjhebnnv_Founder.webp",
  studio:
    "https://customer-assets-v7afamib.emergentagent.net/job_27ef5461-843b-4991-ad70-93e46726bb12/artifacts/fz3jbe2a_AKA%20x%20Master%20A%20Flat%20in%20studio.png",
  console: "https://images.unsplash.com/photo-1517273006195-51fa3364bce2",
  desk: "https://images.pexels.com/photos/8197361/pexels-photo-8197361.jpeg",
};

export const STREAM_LINKS = {
  spotify:
    "https://open.spotify.com/artist/2Y4zPnlSTupUgEdo2VEwSv?si=nWZvkVptRHWaEZ2PuXVetQ",
  apple: "https://music.apple.com/za/artist/master-a-flat/1507577616",
  streamNow:
    "https://open.spotify.com/album/5pieWYLETTSTxvF1Pry22e?si=4emoAokRR56jb2DJdLwsgw",
};

export const CONTACT = {
  directEmail: "mpilo@aflatrecords.co.za",
  bookingEmail: "inquiries@aflatrecords.co.za",
  phone: "+27 79 676 9588",
  phoneRaw: "+27796769588",
  location: "Johannesburg, South Africa",
  timezone: "Africa/Johannesburg",
};

export const SERVICE_OPTIONS = [
  "Production & Songwriting",
  "Executive Production / A&R",
  "Film, TV & Game Scoring",
  "Musical Direction & Live Arrangement",
  "Audio Plugin / Tech Consultation",
  "Other",
];

export const BUDGET_OPTIONS = ["Album", "Single", "EP", "Film / TV Score"];

export const TIMELINE_OPTIONS = ["Immediate", "1-2 Months", "3+ Months", "Flexible"];

// Royalty-free demo audio (SoundHelix) so the player fully works.
const ART = {
  touchMyBlood:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/sbw9kiug_AKA_Touch%20My%20Blood%20Artwork.jpeg",
  familyValues:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/fbdth6vo_Riky%20Rick_Family%20Values%20Artwork.jpg",
  lessTrouble:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/0mucblzt_SHEKHINAH_Less%20Trouble%20Artwork.jpg",
};

const CINEMATIC_COVER =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/971qnfoe_Film%20Score_Artwork.jpeg";

const CATALOG_ART =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/6lei1zst_Master%20A%20Flat%20-%20Catalog%20artwork.webp";

const AUDIO = {
  intro:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/3ybx0z0r_1.%20Intro_Master%20A%20Flat.wav",
  reminisce:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/swxgg6jr_3.%20Reminisce_Master%20A%20Flat.wav",
  friday:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/g7638uf4_Friday%20ft%20Shekhinah.wav",
  emotive:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/vm16f8lv_Emotive.wav",
  unravelling:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/xrjcwhjb_Unravelling.wav",
};

// Tracks that actually play inside the sticky dock (real Master A Flat audio).
export const AUDIO_TRACKS = [
  { id: "intro", title: "Intro", artist: "Master A Flat", cover: CATALOG_ART, src: AUDIO.intro },
  { id: "friday", title: "Friday", artist: "Master A Flat ft. Shekhinah", cover: CATALOG_ART, src: AUDIO.friday },
  { id: "reminisce", title: "Reminisce", artist: "Master A Flat", cover: CATALOG_ART, src: AUDIO.reminisce },
  { id: "emotive", title: "Emotive", artist: "A Flat Records", cover: CINEMATIC_COVER, src: AUDIO.emotive },
  { id: "unravelling", title: "Unravelling", artist: "A Flat Records", cover: CINEMATIC_COVER, src: AUDIO.unravelling },
];

// action: "stream" opens a streaming platform; "audio" previews in the dock.
export const RELEASES = [
  {
    id: "touch-my-blood",
    title: "Touch My Blood",
    artist: "AKA",
    year: "2018",
    genre: "Hip-Hop",
    tag: "Double Platinum",
    cover: ART.touchMyBlood,
    action: "stream",
    href: "https://open.spotify.com/album/1cCpD6ImDJDP1nrsZVhV7O?si=GvJRNDlwRwmxrw-uVSJ49w",
  },
  {
    id: "family-values",
    title: "Family Values",
    artist: "Riky Rick",
    year: "2015",
    genre: "Hip-Hop",
    tag: "Classic",
    cover: ART.familyValues,
    action: "stream",
    href: "https://open.spotify.com/album/4Vka3hwfaOqISTHYyOdkKC?si=lUlS_TimTU2RdcoFZmJTzw",
  },
  {
    id: "less-trouble",
    title: "Less Trouble",
    artist: "Shekhinah",
    year: "2025",
    genre: "POP",
    tag: "Acclaimed",
    cover: ART.lessTrouble,
    action: "stream",
    href: "https://open.spotify.com/album/0Hz8dMfievPvgDBKII1Kgp?si=7hEntpIdQ4Cu4tN6SjlBbA",
  },
  {
    id: "cinematic-vol-1",
    title: "Cinematic Scores, Vol. 1",
    artist: "A Flat Records",
    year: "2024",
    genre: "Film Score",
    tag: "Orchestral",
    cover: CINEMATIC_COVER,
    action: "audio",
    trackId: "emotive",
  },
  {
    id: "master-a-flat-electronic-dance",
    title: "Electronic Dance",
    artist: "Master A Flat",
    year: "2025",
    genre: "Electronic Dance",
    tag: "Original",
    cover: CATALOG_ART,
    action: "audio",
    trackId: "intro",
  },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "The Foundation",
    body: "Founded by veteran music producer, pianist, and musical director Mpilo Shabangu, professionally known as Master A Flat, A Flat Records is an independent production house and label operating at the bleeding edge of modern African and global music culture.",
  },
  {
    no: "02",
    title: "The Blueprint",
    body: "With over fourteen years of professional industry experience, Master A Flat has established a definitive blueprint for sonic innovation, seamlessly bridging intricate technical audio engineering, chart-dominating commercial releases, and boundary-pushing cinematic soundscapes.",
  },
  {
    no: "03",
    title: "The Standard",
    body: "Every release is treated with uncompromising studio precision, built by creators, for creators, and engineered to resonate globally.",
  },
];

export const TRACK_RECORD = [
  {
    k: "Executive Leadership",
    v: "Primary creative partner and executive producer for the late, iconic artist AKA, executive producing the double-platinum certified masterpiece Touch My Blood.",
  },
  {
    k: "Critical Collaborations",
    v: "Key contributor to culture-defining projects, including Riky Rick's seminal album Family Values. Served as Executive Producer on Shekhinah's Less Trouble, home to the standout single “Spoonky” and a 2026 SAMA nominee for Best Pop Album.",
  },
  {
    k: "Genre-Defining Range",
    v: "Built on a legacy of pioneering South African Hip-Hop and driving it into mainstream Pop culture, Master A Flat's sound bridges cultural movement with elite production. From multi-platinum Hip-Hop and Pop records to the sophisticated textures of R&B, Afro-Tech and hybrid electronic-orchestral film scoring, every arrangement is crafted with crossover precision.",
  },
  {
    k: "Industry Leadership",
    v: "Drives the regional and international ecosystem through partnerships with Universal Music South Africa, Sony Music and SAMRO, while innovating studio workflows via proprietary music-tech platforms.",
  },
];

export const STATS = [
  { n: "14+", l: "Years in industry" },
  { n: "1×", l: "Diamond certified" },
  { n: "3", l: "Major label partners" },
  { n: "∞", l: "Sonic range" },
];

export const PARTNERS = [
  "UNIVERSAL MUSIC SA",
  "SONY MUSIC",
  "SAMRO",
  "SAMPRA",
  "RISA",
];

export const ARTISTS = [
  { name: "AKA", role: "Executive Production", img: ASSETS.studio },
  {
    name: "Shekhinah",
    role: "Music Production",
    img: "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/akn6r16z_Shekhinah%20Roster%20image.jpg",
  },
  {
    name: "Riky Rick",
    role: "Collaboration",
    img: "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/5tsoehrv_Riky%20Rick%20collaboration%20image.png",
  },
  { name: "Master A Flat", role: "Founder / Producer", img: "https://customer-assets-cm19k8pv.emergentagent.net/job_precision-sound-2/artifacts/6lei1zst_Master%20A%20Flat%20-%20Catalog%20artwork.webp" },
];
